// extracted by mini-css-extract-plugin
export default {"messenger":"styles_messenger__LC6LR"};